import React, { useEffect } from "react";

/**
 * /design-portfolio route — full-screen tribal-themed gallery (alterable copy of the original portfolio).
 * The static HTML lives in /public/portfolio-design/. We mount it via iframe so the React
 * shell can overlay a guaranteed "Back to portfolio" return path.
 * (Legacy /design route redirects here.)
 */
export default function DesignPage() {
  useEffect(() => {
    document.title = "Design Portfolio — Roshan Raykar";
  }, []);

  return (
    <div className="fixed inset-0 bg-[#0a0a0a]" data-testid="design-page">
      <iframe
        src="/portfolio-design/index.html"
        title="Design portfolio"
        className="w-full h-full border-0"
      />
      {/* Always-visible return overlay */}
      <a
        href="/#path-design-portfolio"
        data-testid="design-back-btn"
        className="fixed top-4 left-4 z-50 inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-[#EDE7D9] text-[#262016] text-sm font-medium shadow-lg hover:bg-white transition-all"
        style={{ fontFamily: "'Space Grotesk', sans-serif" }}
      >
        ← Back to portfolio
      </a>
    </div>
  );
}
